import {
  useState,
  useEffect,
} from 'react';

import {
  TextInput,
  Textarea,
} from 'web-components';

type Props = {
  isTextarea: boolean,
  defaultValue: any,
  placeholder?: string,
  onSave?: { (newValue: string): void },
  onSaveEnter?: { (newValue: string): void },
};

const InlineInput = ({
  isTextarea,
  defaultValue,
  onSave,
  onSaveEnter,
  ...restProps
}: Props) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    setValue(defaultValue || '');
  }, [defaultValue]);

  const Input = isTextarea ? Textarea : TextInput;

  return (
    <Input
      {...restProps}
      value={value}
      onChange={e => setValue(e.target.value)}
      onKeyDown={(e) => {
        if (
          e.key === 'Enter'
          && value !== defaultValue
          && onSaveEnter
        ) {
          onSaveEnter(value);
        }
      }}
      onBlur={() => {
        if (value !== defaultValue) {
          if (onSave) {
            onSave(value);
          } else {
            setValue(defaultValue);
          }
        }
      }}
    />
  );
};

export default InlineInput;
